export type TimelineDensityMode = "BAL" | "ULTRA";

export type TimelineDensityProfile = {
  mode: TimelineDensityMode;
  syncHz: number;
  tileWidth: number;
  sampleIntervalSec: {
    preview: number;
    standard: number;
    high: number;
  };
};

const STORAGE_KEY = "vb:editor2:timelineDensityMode";

const BAL_PROFILE: TimelineDensityProfile = {
  mode: "BAL",
  syncHz: 60,
  tileWidth: 48,
  sampleIntervalSec: {
    preview: 0.35,
    standard: 0.2,
    high: 0.1,
  },
};

const ULTRA_PROFILE: TimelineDensityProfile = {
  mode: "ULTRA",
  syncHz: 120,
  tileWidth: 24,
  sampleIntervalSec: {
    preview: 0.25,
    standard: 0.12,
    high: 0.06,
  },
};

const subscribers = new Set<(mode: TimelineDensityMode) => void>();

export function getTimelineDensityProfile(mode: TimelineDensityMode): TimelineDensityProfile {
  return mode === "ULTRA" ? ULTRA_PROFILE : BAL_PROFILE;
}

export function getStoredTimelineDensityMode(): TimelineDensityMode {
  if (typeof window === "undefined") return "BAL";
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === "ULTRA" ? "ULTRA" : "BAL";
}

export function setStoredTimelineDensityMode(mode: TimelineDensityMode): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, mode);
  subscribers.forEach((cb) => cb(mode));
}

export function subscribeTimelineDensityMode(cb: (mode: TimelineDensityMode) => void): () => void {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}
